"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeature = void 0;

var _uuid = require("uuid");

var _fullscriptJsValidator = require("../fullscriptJsValidator");

var _iframe = require("../iframe");

var _utils = require("../utils");

var _featureUtil = require("./featureUtil");

var getFeature = function getFeature(featureType, featureOptions, fullscriptOptions, dispatcher) {
  var mountPoint;
  var frameId = (0, _uuid.v4)();
  var url = (0, _featureUtil.getFeatureURL)(featureType, featureOptions, fullscriptOptions, frameId); // TODO: If we can only mount a feature once, throw an error if attempting to mount a second time

  var mount = function mount(elementId) {
    mountPoint = document.getElementById(elementId);
    (0, _fullscriptJsValidator.validateMountPoint)(mountPoint);
    var iframe = (0, _iframe.createIframe)(url);
    mountPoint.appendChild(iframe);
  };

  var unmount = function unmount() {
    (0, _utils.removeChildren)(mountPoint);
    dispatcher.unregisterAllFeatureEventListeners(frameId);
  };

  var on = function on(eventType, callback) {
    (0, _fullscriptJsValidator.validateFeatureEventType)(eventType);
    dispatcher.registerEventListener("".concat(frameId, ".").concat(eventType), callback);
  };

  var off = function off(eventType, callback) {
    (0, _fullscriptJsValidator.validateFeatureEventType)(eventType);
    dispatcher.unregisterEventListener("".concat(frameId, ".").concat(eventType), callback);
  };

  return {
    mount: mount,
    unmount: unmount,
    on: on,
    off: off
  };
};

exports.getFeature = getFeature;